import useAuthStore from "@/stores/useAuthStore";
import { CourtSuggestion, CourtSuggestionsResponse } from "@shared/lib/api/courts.types";
import { storeToRefs } from "pinia";
import { ref } from "vue";

export default function () {
  const {
    authHeaders,
  } = storeToRefs(useAuthStore());

  const courtSuggestions = ref<Array<CourtSuggestion>>([]);
  const isFetchingSuggestions = ref(false);
  const courtSessionToken = ref("");
  resetSessionToken();

  let debounceId: ReturnType<typeof setTimeout> | undefined;
  let requestId = 0;

  async function fetchCourtSuggestions (input: string) {
    clearTimeout(debounceId);

    const trimmedInput = input.trim();

    if (!trimmedInput) {
      courtSuggestions.value = [];
      isFetchingSuggestions.value = false;
      requestId++;
      return;
    }

    isFetchingSuggestions.value = true;

    debounceId = setTimeout(async () => {
      const currentRequestId = ++requestId;

      try {
        const query = new URLSearchParams({
          q: trimmedInput,
          session_token: courtSessionToken.value,
        });

        const response = await fetch(`/api/courts/suggestions?${query}`, {
          headers: {
            ...authHeaders.value,
          },
        });

        const data = await response.json() as CourtSuggestionsResponse;

        if (currentRequestId === requestId) {
          courtSuggestions.value = data.suggestions || [];
        }
      } finally {
        if (currentRequestId === requestId) {
          isFetchingSuggestions.value = false;
        }
      }
    }, 250);
  }

  function resetCourtSuggestions () {
    clearTimeout(debounceId);
    courtSuggestions.value = [];
    isFetchingSuggestions.value = false;
    resetSessionToken();
  }

  function resetSessionToken () {
    courtSessionToken.value = crypto.randomUUID();
  }

  return {
    courtSuggestions,
    isFetchingSuggestions,
    courtSessionToken,
    fetchCourtSuggestions,
    resetCourtSuggestions,
  };
}
